// --- Logo Component ---
const CompanyLogo = ({ name }) => (
    <div className="h-8">
        <span className="text-2xl font-semibold text-slate-500 transition-colors duration-300 hover:text-slate-300">{name}</span>
    </div>
);


export default CompanyLogo;